//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var BASE_URL = "/prototype/accounting/general-ledger/reports";
var TPP_URL = BASE_URL + "/tpp-transactions";
import { createExport } from "@/mixins/createExport";
import moment from "moment";

export default {
    mixins: [createExport],
    data: function data() {
        var sortOrders = {};
        return {
            sortKey: '',
            filterKey: '',
            sortOrders: sortOrders,
            start_date: moment().startOf('month').toDate().toISOString().substring(0, 10), //makes html input.type"date" work
            end_date: moment().endOf('month').toDate().toISOString().substring(0, 10),
            items: [],
            loading: false,
            exportExcel: false,
            headers: [{ title: 'Transaction Date', filter: 'dateFull' }, 'Unit', 'Resident Name', { title: 'Payment Amount', filter: 'toCurrency' }, { title: 'Newco Ledger Amount', filter: 'toCurrency' }, { title: 'Processing Fees', filter: 'toCurrency' }, { title: 'Surcharge', filter: 'toCurrency' }, { title: 'Expected Bank Deposit', filter: 'toCurrency' }, { title: 'Adjustment', filter: 'toCurrency' }],
            fields: ['date', 'unit_name', 'resident_name', 'tpp_amount', 'newco_amount', 'fee', 'surcharge', 'expected_settlement', 'adjustment']
        };
    },
    created: function created() {
        var _this = this;

        Event.$on('show-gl-tpp-transactions', function () {
            _this.$children[0].showModal = true;
            _this.load();
        });
    },
    beforeDestroy: function beforeDestroy() {
        Event.$off('show-gl-tpp-transactions');
    },

    methods: {
        load: function load() {
            var _this2 = this;

            this.loading = true;
            Event.$emit('data-table-loading');

            axios.post(TPP_URL, { start_date: this.start_date,
                end_date: this.end_date
            }).then(function (response) {
                console.log(response.data.reports);
                _this2.items = response.data.reports;
                _this2.loading = false;
                Event.$emit('data-table-loaded');
            });
        },
        exportToExcel: function exportToExcel() {
            this.loading = true;

            var data = {
                start_date: this.start_date,
                end_date: this.end_date,
                exportExcel: true
            };

            this.createExport(data, TPP_URL, 'tpp_transactions', '.xlsx');

            this.loading = false;
        },
        exportToPdf: function exportToPdf() {
            this.loading = true;

            var data = {
                start_date: this.start_date,
                end_date: this.end_date,
                exportPdf: true
            };

            this.createExport(data, TPP_URL, 'tpp_transactions', '.pdf');

            this.loading = false;
        }
    },
    computed: {
        // filteredData() {
        //     return this.items; 
        // },
    }

};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/accounting/general-ledger/reports/GlTriplePlayPayTransactions.vue
// module id = yNot
// module chunks = 0 1